(function editProfileControllerDefinition() {

    'use strict';

    angular.module('Profile')
        .controller('EditProfileController', [
            '$scope', 'config', '$state', '$translate', 'errorsExtend', 'userService', '$stateParams', 'authExtend', 'loginService',
            function editProfileController($scope, config, $state, $translate, errors, userService, $stateParams, authExtend, loginService) {

                function refresh() {

                    authExtend.refreshToken()
                        .then(function (result) {
                            if (!result) {
                                login.logOut();
                                return;
                            }
                        },
                            function () {
                                login.logOut();
                            });
                }

                $scope.validMails = function () {
                    if ($scope.user.mail) {
                        if ($scope.user.mail !== $scope.user.emailconfirm) {
                            $scope.userForm.emailconfirm.$invalid = true;
                            $scope.userForm.emailconfirm.$valid = false;
                            return false;
                        } else {
                            $scope.userForm.emailconfirm.$invalid = false;
                            $scope.userForm.emailconfirm.$valid = true;
                            return true;
                        }
                    }
                    return false;
                }

                loginService.getById().then(function (result) {
                    $scope.user = result;
                }, function (error) {
                    errors.showError(error);
                    $state.go('inicio');
                });

                $scope.save = function () {
                    if (!$scope.validMails()) {
                        $scope.userForm.$setSubmitted();
                        errors.showError('UserInvalidMailConfirm');
                        return false;
                    }
                    if (!$scope.userForm.$valid) {
                        $scope.userForm.$setSubmitted();
                        errors.showError('VerifyFormData');
                        return false;
                    }

                    return loginService.modify($scope.user, true).then(function () {
                        refresh();
                        $state.go('profile-detail');
                    }, function (error) {
                        errors.showError(error);
                    });
                };

                $scope.cancel = function () {
                    $state.go("profile-detail");
                };

            }
        ]);
})();